import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Box, Typography } from '@mui/material';

const COLORS = {
  valid: '#4caf50',
  expiring: '#ff9800', 
  expired: '#f44336'
};

const StatusChart = ({ data, title }) => {
  const chartData = data.reduce((acc, item) => {
    const existing = acc.find(d => d.status === item.status);
    if (existing) {
      existing.count += item.count;
    } else {
      acc.push({
        status: item.status,
        count: item.count,
        name: item.status === 'valid' ? 'Válidos' : 
              item.status === 'expiring' ? 'Vencendo' : 'Vencidos'
      });
    }
    return acc;
  }, []);

  return (
    <Box>
      <Typography variant="h6" gutterBottom align="center">
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="count"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[entry.status]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StatusChart;